
import * as Yup from "yup";
import { RegExp } from './constants'

export const TemplateStep2FormValidation = Yup.object().shape( {
    headerType: Yup.string().required( 'Header type required' ), 
    rowNumber: Yup.number().required( 'Row number required' ),
    columnNumber: Yup.number().required( 'Column number required' ),
    csvTypeId: Yup.object().shape( {
        label: Yup.string().required( 'Template type required' ),
        value: Yup.string().required( 'Template type required' ),
    } ).required( 'Template type required' ),
    networkId: Yup.object().shape( {
        label: Yup.string(),
        value: Yup.string(),
    } ).nullable(),
    templateName: Yup.string().required( 'Template name required' ),
} );

export const addNetworkValidation = Yup.object().shape( {
    csvTypeId: Yup.object().shape( {
        label: Yup.string().required( 'Template type required' ),
        value: Yup.string().required( 'Template type required' ),
    } ).required( 'Template type required' ),
    name: Yup.string().required( 'Name required' ),
    status: Yup.string().required( 'Status required' )
} );

export const addTemplateTypeValidation = Yup.object().shape( {
    name: Yup.string().required( "Name is required" ),
    status: Yup.string().required( "Status is required" ),
    columns: Yup.array().of( 
        Yup.object().shape({
            name: Yup.string().required('Name required'),
            columnType: Yup.string().required('columnType required'),
        })
     ).min( 1 )
    // columns: Yup.array().min(1, 'Atleast one column required').required("Provide at least one column"),
} );

export const updateTemplateTypeColumnValidation = Yup.object().shape( {
    name: Yup.string().required( "Name is required" ),
    status: Yup.string().required( "Status is required" ),
    columnType: Yup.string().required('columnType required')
} );

export const ToolsFormValidation = Yup.object().shape({
    start_time: Yup.string().required( 'Start time required' ),
    end_time: Yup.string()
    .when('start_time', {
        is: (value: any) => value,
        then: Yup.string().test('time_compare', 'End time should be greater than Start time', function(value) {
            const startTime = this.parent.start_time;
            const startHour = +startTime.split(':')[0];
            const EndHour = value && +value.split(':')[0] || 0;
            const startMinute = +startTime.split(':')[1];
            const EndMinute = value && +value.split(':')[1] || 0;

            if ( startHour < EndHour || ( startHour == EndHour && startMinute < EndMinute )  ) {
                return true;
            } else {
                return false;
            }
        })
    })
    .required( 'End time required' ),
    call_duration: Yup.object().shape( {
        label: Yup.string().required( 'Duration required' ),
        value: Yup.string().required( 'Duration required' ),
    } ).required( 'Duration required' ),
});

export const AccountFormValidations = Yup.object().shape( {
    name: Yup.string()
        .min( 5, "Name must be at least 5 chars" )
        .max( 100, "Name is too long, max 100 chars" )
        .required( "Required" ),
    phone1: Yup.string()
        .matches( RegExp.phoneRegExp, 'Phone number is not valid' )
        .min( 12, "Phone must be at least 12 chars" )
        .max( 12, "Phone is too long, max 12 chars" )
        .required( "Required" ),
    phone2: Yup.string()
        .matches( RegExp.phoneRegExp, 'Fax number is not valid' )
        .min( 12, "Fax must be at least 12 chars" )
        .max( 12, "Fax is too long, max 12 chars" )
} );

export const ChangePasswordFormValidations = Yup.object().shape( {
    current_password: Yup.string()
        .required( "Required" ),
    new_password: Yup.string()
        .min( 8, "Password must be at least 8 chars" )
        .max( 20, "Password is too long, max 20 chars" )
        .required( "Required" ),
    password_confirmation: Yup.string()
        .required( "Required" )
        .oneOf( [Yup.ref( 'new_password' )], 'Your passwords do not match.' )
} );

export const AddUserFormValidation = Yup.object().shape( {
    name: Yup.string()
        .required( "Name is required" ),
    email: Yup.string()
        .email( 'Invalid email address' )
        .required( "Email is required" ),
    role: Yup.string()
        .required( "Role is required" ),
    phone: Yup.string()
        .transform(function (value, originalvalue) {
            return value !== null ? value.replace( /\D+/g, '' ) : value;
        })
        .min(10, "Invalid phone number")
        .max(10, "Invalid phone number")
        .nullable()
} );